import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from 'react-icons/io';

import styles from './TileFooter.module.css';
import tileStyles from '../../../styles/tiles.module.css';

type Props = {
  redirectTo: string;
  text?: string;
  onClick?: () => void;
};

const TileFooter: React.FC<Props> = ({
  redirectTo,
  text = 'See All',
  onClick
}) => {
  return (
    <div className={tileStyles.actionContainer}>
      <Link to={{ pathname: redirectTo }} onClick={onClick}>
        <div className={styles.button}>
          <div className={styles.text}>{text}</div>
          <IoIosArrowForward className={styles.arrowIcon} />
        </div>
      </Link>
    </div>
  );
};

export default TileFooter;
